// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const CommandContract = contract({
  name: "Command",
  description: "A searchable list of actions or destinations — global ⌘K palettes, \"jump to\" inputs, account switchers with filter. Wrap in CommandDialog when it should pop over the entire app on a hotkey. For straight forms with filter, prefer a Select with a search input. For free-text autocomplete tied to a single value, prefer Combobox built on Popover + Command.",
  import: "@gradeui/ui",
  aliases: ["command palette","command menu","cmd k","quick switcher","action menu","spotlight","spotlight search","quick open","fuzzy finder"],
  subcomponents: ["CommandInput","CommandList","CommandEmpty","CommandGroup","CommandItem","CommandSeparator","CommandShortcut","CommandDialog"],
  composesWith: ["Dialog (CommandDialog wraps it)","Popover (inline combobox)","Tooltip"],
  styleDefaults: {"Command":"flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground","CommandInput":"flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50","CommandList":"max-h-[300px] overflow-y-auto overflow-x-hidden","CommandGroup":"overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground","CommandSeparator":"-mx-1 h-px bg-border","CommandItem":"relative flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0","CommandShortcut":"ml-auto text-xs tracking-widest text-muted-foreground"},
  props: {
  "value": {
      schema: z.string().optional(),
      design: "content",
      description: "controlled active item value",
  },
  "onValueChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "placeholder": {
      schema: z.string().optional(),
      design: "content",
  },
  "children": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "wraps groups and empty state",
  },
  "heading": {
      schema: z.string().optional(),
      design: "content",
  },
  "onSelect": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "disabled": {
      schema: z.boolean().optional(),
      design: "knob",
  },
  "open": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "onOpenChange": {
      schema: z.unknown().optional(),
      design: "event",
      description: "when you want the command palette mounted in a modal (cmd+k pattern)",
  },
  },
});
